var time1
var time2;
var arrayReactionTime = [];

class ServiceReactionTimeManager {
    constructor() {}
    
    getArrayReactionTime() {
        return arrayReactionTime;
    }
    resetArrayReactionTime() {
        arrayReactionTime = [];
    }
    startTimeReaction() {
        this.setTime1();
    }
    setTime1() {
        time1 = Date.now();
    }
    setTime2() {
        time2 = Date.now();
    }
    addInArrayReactionTime() {
        arrayReactionTime.push(time2 - time1);
    }
    saveTimeToReact() {
        this.setTime2();
        this.addInArrayReactionTime();
        this.setTime1();
    }
}

let reactionTimeInstance = null;

export function InitReactionTime() {
    reactionTimeInstance = new ServiceReactionTimeManager();
    return reactionTimeInstance;
}

export default function GetReactionTimeInstance() {
    if (!reactionTimeInstance) {
        InitReactionTime();
    }
    return reactionTimeInstance;
}